import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

const title = 'Tenant ID';

export const AzureTenantSelect = ({
  tenantId,
  onChange,
}: {
  tenantId?: string;
  onChange: (tenantId: string) => void;
}) => {
  const dal = useDAL();
  const { data: tenants, isLoading } =
    dal.cloudAccounts.azureApps.useListTenants();

  if (!tenants?.tenantIds.length || isLoading) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={tenantId}
        onChange={(_, newValue) => onChange(newValue || '')}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              slotProps={{ inputLabel: { shrink: true } }}
            />
          );
        }}
        options={tenants.tenantIds}
      />
    </FormControl>
  );
};
